// Authentication error codes
export const REIMBURSEMENT_ACCOUNT_LOGIN_REQUIRED = 'REIMBURSEMENT_ACCOUNT_LOGIN_REQUIRED';
export const REIMBURSEMENT_LOGIN_WRONG_CREDENTIALS = 'REIMBURSEMENT_LOGIN_WRONG_CREDENTIALS';
export const REIMBURSEMENT_ACCOUNT_NOT_FOUND = 'REIMBURSEMENT_ACCOUNT_NOT_FOUND';
export const REIMBURSEMENT_ACCOUNT_ALREADY_EXISTS = 'REIMBURSEMENT_ACCOUNT_ALREADY_EXISTS';

// General error codes
export const GENERAL_ERROR = 'GENERAL_ERROR';
export const VALIDATION_ERROR = 'VALIDATION_ERROR';
export const UNAUTHORIZED = 'UNAUTHORIZED';
export const FORBIDDEN = 'FORBIDDEN';
export const NOT_FOUND = 'NOT_FOUND';

// Success codes
export const SUCCESS = 'SUCCESS';
export const CREATED = 'CREATED';

